const grantedCourseIds = new Set<number>()

/** El curso acaba de crearse y aún no está en el payload de permisos. */
export const grantCourseAccess = (courseId: number) => {
  const id = Number(courseId)
  if (!Number.isFinite(id)) return

  grantedCourseIds.add(id)
}

export const hasGrantedCourseAccess = (courseId: number) =>
  grantedCourseIds.has(Number(courseId))
